import { ResponseError } from '@shared/utils/interfaces';

export const getErrorObjectsList = (error: ResponseError): string => {
  const flatObjects = error.objects.flat().filter(Boolean);

  return flatObjects.join(', ');
};

export const getLastErrorObject = (error: ResponseError): string => {
  const flatObjects = error.objects.flat().filter(Boolean);

  return flatObjects[flatObjects.length - 1] as string;
};
